import React from "react";
import SarfPanel from "./SarfPanel";

/**
 * SarfTool — the in-app overlay wrapper around SarfPanel (the working
 * surface shared with the public /sarf page). Opened from the sidebar.
 * Escape handling lives in SarfPanel, mirroring IrabTool/IrabPanel.
 */
export default function SarfTool({ onClose, initialText = "", autoAnalyze = false }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-start sm:items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm">
      <SarfPanel onClose={onClose} context="overlay" initialText={initialText} autoAnalyze={autoAnalyze} />
    </div>
  );
}
